import React, { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const RpmFilter = ({ isOpen, onClose, fetchdata, resetSignal, onResetHandled }) => {
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [selectedKey,setSelectedKey]=useState(null)

  useEffect(() => {
    if (resetSignal) {
      setSelectedKey(null);
      setSelectedFilter(null);
      onResetHandled();
    }
  }, [resetSignal]);

  if (!isOpen) return null; // If `isOpen` is false, do not render the modal

  // Function to handle the filter button click
  const handleFilterClick = (filterType ,selectedKey) => {
       setSelectedKey(filterType)
       setSelectedFilter(selectedKey)
  };

  // Function to handle the apply button click
  const handleApplyFilter = () => {
    if (selectedFilter && selectedKey) {
      fetchdata({ [selectedFilter]: selectedKey });
    }
    onClose(); // Close the modal
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 h-auto overflow-scroll custom-scrollbar" style={{scrollbarWidth:'none'}}>
      <div className="bg-white rounded-lg shadow-lg w-full max-w-[80%] lg:max-w-[30%]  mx-4 sm:mx-auto my-4">
        <div className="flex justify-between items-center border-b p-3 bg-[#E179544A]">
          <h2 className="text-xl font-semibold">Filter</h2>
          <button
            onClick={onClose} // When clicked, it calls onClose to close the modal
            className="text-gray-500 hover:text-gray-700 text-3xl"
          >
            <CloseIcon style={{width:"22px"}}/>
            </button>
        </div>

        <div className="p-4">
          {/* Filter buttons */}
          <div className="flex gap-4 flex-column">
            <button
              onClick={() => handleFilterClick("HIGHRISK",'highriskpat')}
              className={`${
                selectedFilter === 'highriskpat' ? 'bg-[#F97316]' : 'bg-white'
              } border-[1.4px] border-gray-200 text-gray-600 text-sm px-6 py-[12px] rounded-full hover:bg-[#F97316]`}
            >
              High Risk
            </button>
            <button
              onClick={() => handleFilterClick("CALLBACK",'callbackpat')}
              className={`${
                selectedFilter === 'callbackpat' ? 'bg-[#F97316]' : 'bg-white'
              } border-[1.4px] border-gray-200 text-gray-600 text-sm px-6 py-[12px] rounded-full hover:bg-[#F97316]`}
            >
              CallBack
            </button>
            <button
              onClick={() => handleFilterClick("DEVICEBACK",'devicebackpat')}
              className={`${
                selectedFilter === 'devicebackpat' ? 'bg-[#F97316]' : 'bg-white'
              } border-[1.4px] border-gray-200 text-gray-600 text-sm px-6 py-[12px] rounded-full hover:bg-[#F97316]`}
            >
              Device Recall
            </button>
          </div>

          {/* Action buttons */}
          <div className="flex justify-between mt-4">
            <button
              onClick={onClose} // Close the modal when clicked
              className="bg-gray-300 hover:bg-gray-400 text-gray-700 text-sm px-6 py-2 rounded-lg"
            >
              Close
            </button>
            <button
              onClick={handleApplyFilter} // Apply filter and close modal
              className="bg-[#F97316] hover:bg-blue-600 text-white text-sm px-6 py-2 rounded-lg"
            >
              Apply Filter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RpmFilter;
